import { Card, Col, Form, FormGroup, Input, Label,  Row } from "reactstrap";
import { Badges } from "../../../../AbstractElements";
import { WITHOUT_BORDER_LIST } from "../../../../Data/FormControl/MegaOptions";

const WithoutBordersStyleForm = () => {
  return (
    <Form className="mega-inline plain-style">
      <Row>
        {WITHOUT_BORDER_LIST.map(({ id, color, badgeTitle, digits, plansText, check }) => (
          <Col sm="6" key={id}>
            <Card>
              <div className="d-flex p-20">
                <FormGroup className={`checkbox checkbox-${color} m-0`} check>
                  <Input id={`checkbox${id}`} type="checkbox" defaultChecked={check} />
                  <Label htmlFor={`checkbox${id}`} check>
                    <span className="flex-grow-1 megaoption-space">
                      <span className="mt-0 mega-title-badge">
                        {badgeTitle}
                        <Badges color={color} className="pull-right digits">
                          {digits}
                        </Badges>
                      </span>
                      <span> {plansText}</span>
                    </span>
                  </Label>
                </FormGroup>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </Form>
  );
};

export default WithoutBordersStyleForm;
